export class EstadoCivil {
  idEstadoCivil: number = null;
  dsEstadoCivil: string = null;

  constructor(d?) {
    if (d) {
      this.idEstadoCivil = d.idEstadoCivil ? d.idEstadoCivil : null;
      this.dsEstadoCivil = d.dsEstadoCivil ? d.dsEstadoCivil : null;
    }
  }
}
